import { ReactNode, useEffect, useState } from "react";
import { IntlProvider } from "react-intl";
import enMessages from "../i18n/en.json";
import msMessages from "../i18n/ms.json";
import zhMessages from "../i18n/zh.json";

const messages: Record<string, Record<string, string>> = {
  en: enMessages,
  ms: msMessages,
  zh: zhMessages,
};

type Props = {
  children: ReactNode;
};

const IntlProviderWrapper = ({ children }: Props) => {
  const [locale, setLocale] = useState(
    localStorage.getItem("language") ?? "en"
  );

  useEffect(() => {
    const handleCustomEvent = (event: CustomEvent) => {
      localStorage.setItem("language", event.detail.language);
      setLocale(event.detail.language);
    };

    window.addEventListener(
      "languageChange",
      handleCustomEvent as EventListener
    );

    return () => {
      window.removeEventListener(
        "languageChange",
        handleCustomEvent as EventListener
      );
    };
  }, []);

  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      {children}
    </IntlProvider>
  );
};

export default IntlProviderWrapper;
